import script from "./toasts.vue?vue&type=script&setup=true&lang=ts"
export * from "./toasts.vue?vue&type=script&setup=true&lang=ts"

import "./toasts.vue?vue&type=style&index=0&id=fd2be30e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cow-app/cow-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd2be30e"]])

export default __exports__